import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=3b95cda4&"
import script from "./FormView.vue?vue&type=script&lang=js&"
export * from "./FormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports